import { isValidPlanLevel, PlanLevel } from 'app/constants/tiers'
import { gql } from 'graphql-request'

export const createTiersQuery = () => gql`
  {
    MemberTiers {
      docs {
        id
        memberfulPlans {
          memberfulPlan {
            externalId
            type
            price
            savings
            smallPrint
          }
        }
        planLevel
        name
      }
    }
  }
`

export type { PlanLevel } from 'app/constants/tiers'

export type Frequency = 'monthly' | 'quarterly' | 'annually'

export interface Tier {
  id: string
  name: string
  planLevel: PlanLevel
  memberfulPlans: {
    type: Frequency
    externalId: string
    price: string
    savings: string
    ctaLabel: string
    smallPrint: string
  }[]
}

export const mapToTiers = (data: any): Tier[] =>
  data.MemberTiers.docs
    .filter((tier: any) => isValidPlanLevel(tier.planLevel))
    .map((tier: any) => ({
      id: tier.id,
      name: tier.name,
      planLevel: tier.planLevel as PlanLevel,
      memberfulPlans: tier.memberfulPlans.map(
        (memberfulPlan: any) => memberfulPlan.memberfulPlan,
      ),
    }))
